import {
    Avatar,
    Box,
    Button,
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Popover,
    Typography,
    Divider,
} from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import { useUserDispatch, useUserState } from "../../providers/UserProvider";
import LogoutIcon from "@mui/icons-material/Logout";
import MenuBookIcon from "@mui/icons-material/MenuBook";

function UserControls() {
    const user = useUserState().result;
    const [anchorEl, setAnchorEl] = React.useState<any | null>(null);
    const open = Boolean(anchorEl);
    const id = open ? "simple-popover" : undefined;
    const dispatch = useUserDispatch();
    const navigate = useNavigate();

    const handleNavigateToDict = () => {
        setAnchorEl(null);
        navigate("/dict");
    };

    return (
        <>
            <Button
                color="secondary"
                onClick={(event) => setAnchorEl(event.currentTarget)}>
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        flexWrap: "wrap",
                    }}>
                    <Avatar>B</Avatar>
                    <Typography
                        variant="h5"
                        sx={{
                            color: "white",
                            mt: "3px",
                            ml: "5px",
                            textTransform: "none",
                        }}>
                        {user.user?.name}
                    </Typography>
                </div>
            </Button>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={() => setAnchorEl(null)}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                }}>
                <Box sx={{ width: "100%", maxWidth: 360, bgcolor: "background.paper" }}>
                    <nav aria-label="user controls">
                        <List>
                            {user.user?.isAdmin && (
                                <ListItem disablePadding>
                                    <ListItemButton onClick={handleNavigateToDict}>
                                        <ListItemIcon>
                                            <MenuBookIcon />
                                        </ListItemIcon>
                                        <ListItemText primary="Справочники" />
                                    </ListItemButton>
                                </ListItem>
                            )}
                            {user.user?.isAdmin && <Divider />}
                            <ListItem disablePadding>
                                <ListItemButton onClick={() => dispatch({ type: "logout" })}>
                                    <ListItemIcon>
                                        <LogoutIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Log out" />
                                </ListItemButton>
                            </ListItem>
                        </List>
                    </nav>
                </Box>
            </Popover>
        </>
    );
}

export default UserControls;